"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PotencyType = void 0;
var PotencyType;
(function (PotencyType) {
    PotencyType["ABV"] = "ABV";
    PotencyType["PROOF"] = "Proof";
    PotencyType["CBD"] = "CBD";
    PotencyType["THC"] = "THC";
    PotencyType["PG"] = "PG Ratio";
    PotencyType["VG"] = "VG Ratio";
    PotencyType["NICOTINE_STRENGTH"] = "Nic. Strength";
})(PotencyType || (exports.PotencyType = PotencyType = {}));
//# sourceMappingURL=potency.js.map